<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex
        d-flex
        v-for="(card, index) in cards"
        v-bind="{ [`xs${card.xsflex} sm${card.smflex} md${card.mdflex}` ]: true }"
        :key="index"
      >
        <photo-card :photoJson="card" :toLink="'/photos/' + card.pindex" :cardStyle="cardStyle">
        </photo-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import photoJson from '../photos.json';
import PhotoCard from '@/components/PhotoCard.vue';

export default {
  name: 'photos',
  data() {
    return {
      cards: photoJson,
      cardStyle: 'background: #FFFFFF;',
    };
  },
  components: {
    PhotoCard,
  },
};

</script>
